import './styles.scss';

import { Container } from 'react-bootstrap';

import Feature from '@/common/Feature';
import { Import } from '@/models/gen/graphql';
import { LoadingBlur } from '@/components/LoadingSpinner';
import PageHeader from '@/features/DriveTimeTool/components/PageHeader';
import { createComponentState } from '@/state';
import { sleep } from '@/utils';
import { useEffect } from 'react';

export type DriveTimeToolImportsState = {
  imports: Import[];
  loading: boolean;
};
export const useDriveTimeToolImports = createComponentState<DriveTimeToolImportsState>({
  imports: [],
  loading: false,
});

const DriveTimeToolImports = (): JSX.Element => {
  const [state, setState] = useDriveTimeToolImports(({ state, setState }) => [state, setState]);
  const { loading } = state;

  const getImports = async () => {
    try {
      setState((current) => ({ ...current, loading: true }));
      const imports = []; // Replace with actual fetch logic
      await sleep(3000); // Simulate network delay
      setState((current) => ({ ...current, imports }));
    } catch (err) {
      console.error('Error fetching imports:', err);
    } finally {
      setState((current) => ({ ...current, loading: false }));
    }
  };

  useEffect(() => {
    getImports();
  }, []);

  return (
    <Feature name="DriveTimeToolImports">
      <Container fluid>
        <LoadingBlur loading={loading} />
        <PageHeader
          title="Import History"
          subtitle="Manage and analyze your uploaded manifest documents"
          icon={<i className="fa fa-upload" />}
          info="ESC: Back to main"
          back="Back to Main"
        />
      </Container>
    </Feature>
  );
};

export default DriveTimeToolImports;
